import { PackageGeneralFormController } from '../controller/PackageGeneralFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { DeepPartial } from 'typeorm';
import { PackageData } from '../../../types/package-data';
import { Observable } from 'rxjs';
import { PackageActionContext } from '../../types/PackageActionContext';
import _ from 'lodash';
import { PackagePanelType, PackageType } from '../../../packagesGrid/types';
import { Company } from '../types/PackageGeneralFormViewData';

export class PackageGeneralFormWebComponent extends BaseWebComponentElement {
  public controller!: PackageGeneralFormController;
  private packageType: PackageType;
  private _packageId: string | null;
  private companyData: Company | undefined;
  private _panelType: PackagePanelType;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackageGeneralFormController,
    });
  }

  public get value(): DeepPartial<PackageData> {
    const baseGeneralData: DeepPartial<PackageData> = {
      company: {
        id: this.company,
      },
    };
    return _.merge(this.controller.view.formGroup.value, baseGeneralData);
  }

  public get company(): string {
    return this.controller.view.dom.$companyFormField.value || this.dependencies.getCurrentUserCompany().id;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get formContext(): PackageActionContext {
    const context = this.getAttribute('context');

    if (!PackageActionContext.isValid(context)) {
      throw new Error(`PackagePanel context not valid: ${context}`);
    }

    return context as PackageActionContext;
  }

  public set formContext(context: PackageActionContext) {
    this.setAttribute('context', context);
  }

  public async setPackageData(packageData: PackageData): Promise<void> {
    await this.controller.view.setPackageData(packageData);
  }

  public setPackageType(productType: PackageType): void {
    this.packageType = productType;
  }

  public getPackageType(): PackageType {
    return this.packageType;
  }

  public set packageId(packageId: string | null) {
    this._packageId = packageId;
  }

  public get panelType(): PackagePanelType {
    return this._panelType;
  }

  public set panelType(panelType: PackagePanelType) {
    this._panelType = panelType;
  }

  public get packageId(): string | null {
    return this._packageId;
  }

  public setCompany(company: { id: string; name: string } | undefined): void {
    this.companyData = company;
  }

  public getCompany(): Company {
    return this.companyData as Company;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }

  public triggerCompanyChangeEvent(companyId: string): void {
    this.controller.view.onCompanyChanged(companyId);
  }

  public isCompanyAvailable() {
    return this.controller.view.isCompanyAvailable();
  }
}
